import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=08f3aeb9&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f3aeb9')) {
      api.createRecord('08f3aeb9', component.options)
    } else {
      api.reload('08f3aeb9', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=08f3aeb9&", function () {
      api.rerender('08f3aeb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4EKx3r5XlwVPL/JS/imageCarousel.vue"
export default component.exports